import React from 'react'
import { useState,useEffect } from 'react'
import Searchbar from '../../components/forms/searchbar';
import ApiUrl from '../../configTools/apiUrl';

const Insights = () => {
  const [User, setUser] = useState(JSON.parse(localStorage.getItem("user-info")));
  const [Insights, setInsights] = useState([]);
  const [Filter,setFilter] = useState([]);
  function filterFunction(value){
    if(value === ""){
        setFilter(Insights);
    }
    else{
      const filtedInsight = Insights.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setFilter(filtedInsight);
    }
  }
  useEffect(()=>{
    fetch(ApiUrl.API_URL_Insights,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
      setInsights(data.responce);
      setFilter(data.responce);
    });
  },[])
  return (
    <div>
      <div className='form_table_container'>
        <Searchbar Filter={filterFunction}/>
        <table>
          <thead>
              <tr className='form_item_row_container title'>
                <td className='form_item_row_container_item' style={{width:'5%'}}>
                    
                </td>
                <td className='form_item_row_container_item' style={{width:'55%'}}>
                    <p>Title</p>
                </td>
                <td className='form_item_row_container_item' style={{width:'20%'}}>
                    <p>Impressions</p>
                </td>
                <td className='form_item_row_container_item' style={{width:'20%'}}>
                    <p>Clicks</p>
                </td>
              </tr>
          </thead>
          <tbody>
          {
            Filter.map((item,index)=>{
              return(
                <tr className='form_item_row_container discription' key={index}>
                  <td className='form_item_row_container_item' style={{width:'5%'}}>
                    <img src={ApiUrl.API_URL_Image_Thumbnail+item.image} alt='proimage' className='full_width_image'/>
                  </td>
                  <td className='form_item_row_container_item' style={{width:'55%'}}>
                    <p>{item.title}</p>
                  </td>
                  <td className='form_item_row_container_item' style={{width:'20%'}}>
                    <p>{item.impressions}</p>
                  </td>
                  <td className='form_item_row_container_item' style={{width:'20%'}}>
                    <p>{item.clicks}</p>
                  </td>
                </tr>
              );
            })
          }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Insights
